export default {"src":"/_next/static/media/btn-logo.50c723ec.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};